import { BackendApi } from '@/services/backend_api'

const BASE_PATH = 'relatorios/estatistico'
const EXPORT_TIMEOUT_MS = 600000
const DOWNLOAD_TIMEOUT_MS = 120000

function buildExportParams (year, relatorio) {
  const params = {}
  if (relatorio && relatorio.compareYear) {
    params.compareYear = relatorio.compareYear
  }
  return params
}

function buildPreparePath (type, year) {
  if (type === 'pdf') {
    return `${BASE_PATH}/${year}/document/prepare`
  }

  return `${BASE_PATH}/${year}/${type}/prepare`
}

function downloadPrepared (type, year, relatorio) {
  const client = BackendApi.getClient()
  const params = buildExportParams(year, relatorio)

  return client.get(buildPreparePath(type, year), {
    params,
    timeout: EXPORT_TIMEOUT_MS
  }).then(function (prepareResponse) {
    const payload = prepareResponse.data || {}

    if (payload.errors && payload.errors.length > 0) {
      throw new Error(payload.errors.join(', '))
    }

    if (!payload.downloadUrl) {
      throw new Error('Não foi possível preparar o arquivo para download.')
    }

    return client.get(payload.downloadUrl, {
      responseType: 'blob',
      timeout: DOWNLOAD_TIMEOUT_MS
    }).then(function (fileResponse) {
      fileResponse.preparedFilename = payload.filename
      fileResponse.preparedFallback = payload.fallback
      return fileResponse
    })
  })
}

export default {
  get (year, params = {}) {
    return BackendApi.getClient().get(`${BASE_PATH}/${year}`, {
      params,
      timeout: 600000
    })
      .then(response => response.data)
  },
  downloadExcel (year, params = {}) {
    return BackendApi.getClient().get(`${BASE_PATH}/${year}/excel`, {
      params,
      responseType: 'blob',
      timeout: EXPORT_TIMEOUT_MS
    })
  },
  downloadExcelFromPayload (year, relatorio) {
    return downloadPrepared('excel', year, relatorio)
  },
  downloadPdf (year, params = {}) {
    return BackendApi.getClient().get(`${BASE_PATH}/${year}/pdf`, {
      params,
      responseType: 'blob',
      timeout: EXPORT_TIMEOUT_MS
    })
  },
  downloadPdfFromPayload (year, relatorio) {
    return downloadPrepared('pdf', year, relatorio)
  }
}



// WEBPACK FOOTER //
// ./src/services/resource_client/relatorio_estatistico.js